module.exports = __webpack_public_path__ + "bb808d09f2bf92b497f8e3b6e6b3029c.svg";